module.exports = __webpack_public_path__ + "img/3.094520b2.png";